import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { Api } from '../../../../../shared/constants/api';
import { RoutingService } from '../../../services/routing.service';
import { RestService } from '../../../services/rest.service';
import { RestBuilder } from '../../../services/helpers/rest.builder';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { NotificationService } from '../../../services/notification.service';
import { NotificationPosition } from '../../../models/notification.model';
import { TranslateService } from '../../../translate/translate.service';

@Component({
  selector: 'app-task-attachment-download',
  templateUrl: './task-attachment-download.component.html',
  standalone: false,
})
export class TaskAttachmentDownloadComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();

  public pageTitle: string;

  constructor(
    private routingService: RoutingService,
    private activatedRoute: ActivatedRoute,
    private restService: RestService,
    private router: Router,
    private errorHandlerService: ErrorHandlerService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  private downloadAttachment(taskId: string, attachmentId: string): void {
    const url: string = new RestBuilder().create().taskAttachmentDownload(taskId, attachmentId).getApiUrl();

    this.subscriptions.add(
      this.restService.download(url).subscribe({
        error: (error: HttpErrorResponse): void => {
          const errorMessage: string = this.translateService.instant('failed_download_file');
          this.notificationService.error(errorMessage, NotificationPosition.Toast);
          console.error(`[${TaskAttachmentDownloadComponent.name}] failed to download attachment`, error);
          this.router.navigateByUrl('/').catch(this.errorHandlerService.handleRoutingError.bind(this.errorHandlerService));
        },
      }),
    );
  }

  public ngOnInit(): void {
    this.pageTitle = this.routingService.getPageTitle();
    const params: Params = this.activatedRoute.snapshot.params;
    this.downloadAttachment(params[Api.taskId], params[Api.attachmentId]);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
